/**
 * External dependencies
 */
import mergeRefs from 'react-merge-refs';
/**
 * WordPress dependencies
 */

import { useRef, useEffect } from '@wordpress/element';
import { ESCAPE } from '@wordpress/keycodes';
/**
 * Internal dependencies
 */

import useConstrainedTabbing from '../use-constrained-tabbing';
import useFocusOnMount from '../use-focus-on-mount';
import useFocusReturn from '../use-focus-return';
import useFocusOutside from '../use-focus-outside';
import useCallbackRef from '../use-callback-ref';
/**
 * Returns a ref and props to apply to a dialog wrapper to enable the following behaviors:
 *  - constrained tabbing.
 *  - focus on mount.
 *  - return focus on unmount.
 *  - focus outside.
 *
 * @param {Object} options Dialog Options.
 */

function useDialog(options) {
  var onClose = useRef();
  useEffect(function () {
    onClose.current = options.onClose;
  }, [options.onClose]);
  var constrainedTabbingRef = useConstrainedTabbing();
  var focusOnMountRef = useFocusOnMount();
  var focusReturnRef = useFocusReturn();
  var focusOutsideProps = useFocusOutside(options.onClose);
  var closeOnEscapeRef = useCallbackRef(function (node) {
    if (!node) {
      return;
    }

    node.addEventListener('keydown', function (event) {
      // Close on escape
      if (event.keyCode === ESCAPE && onClose.current) {
        event.stopPropagation();
        onClose.current();
      }
    });
  }, []);
  return [mergeRefs([constrainedTabbingRef, focusReturnRef, focusOnMountRef, closeOnEscapeRef]), focusOutsideProps];
}

export default useDialog;
//# sourceMappingURL=index.js.map